// GlobalDataMixin.js

export default {
    data() {
      return {
        userData: JSON.parse(localStorage.getItem('user_cms')) || null,
      };
    },
  };
  